import {Component} from '@angular/core';
import {HeaderComponent} from '../../../header/header.component';

@Component({
    selector: 'core-side-nav-footer',
    templateUrl: './side-nav-footer.component.html',
    standalone: false,
})
export class SideNavFooterComponent extends HeaderComponent {
}
